
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowUpRight } from 'lucide-react';

interface AnimatedLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  icon?: boolean;
}

export const AnimatedLink: React.FC<AnimatedLinkProps> = ({
  to,
  children,
  className = '',
  fullWidth = false,
  icon = true
}) => {
  return (
    <Link to={to}>
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
      >
        <Button className={`${fullWidth ? 'w-full' : ''} btn-hover-glow group ${className}`}>
          {children}
          {icon && (
            <ArrowUpRight className="ml-1 h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          )}
        </Button>
      </motion.div>
    </Link>
  );
};

export default AnimatedLink;
